import script from "./DetailScore.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailScore.vue?vue&type=script&setup=true&lang=js"

import "./DetailScore.vue?vue&type=style&index=0&id=ad0f756c&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad0f756c"]])

export default __exports__